export default __webpack_public_path__ + "static/media/T680_SOV.8f274435.pdf";